import script from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"

import "./MoneyInput.vue?vue&type=style&index=0&id=78319186&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78319186"]])

export default __exports__